import React from "react"
import { ScrollView, Text, View } from "react-native";
import { store } from "../../../store/store";

export default class ImageWithPointer extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            questionData: {},
         }
    }

    componentDidMount() {
        const reduxState = store.getState();
        if(reduxState.currentConsultationQuestion) {
            this.setState({questionData : reduxState.currentConsultationQuestion})
        }
    }

    render() {
        return <View>
            <Text>Data</Text>
        </View>
    }
    
}